<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-top">
                    <div class="row">

                        <div class="col-lg-6">
                            <div class="about-enago">
                                <h3>關於Trinka</h3>
                                Trinka是一個人工智慧驅動的英語文法檢查器和語言增強寫作助手，專為學術和技術寫作而設計。Trinka通過即時提供寫作建議，能依據上下文糾正拼寫錯誤和高級語法錯誤。它幫助專業人士和學者確保寫作正式、簡潔並且引人入勝。Trinka的企業解決方案除了能無限使用Trinka的所有強大功能之外，還提供自訂選項。
                                <p>
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="install-in">
                                <h3>在以下程式中使用</h3>
                                <ul>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/wordplugin">
                                                <img src="../../../assets/images/NewWordAdd_in.svg" alt="word addin"> </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/wordplugin">微軟Word (Windows)</a>
                                        </span>
                                        <!-- <a routerLink="/wordplugin"></a> -->
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin">
                                                <img src="../../../assets/images/NewChromeFicon.svg" alt="chrome">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin">Google Chrome
                                            </a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin">
                                                <img src="../../../assets/images/NewFirefoxFicon.svg" alt="firefox">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin">Mozilla Firefox
                                            </a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin">
                                                <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge" width="42">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin">Microsoft Edge
                                            </a>
                                        </span>

                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <img src="../../../assets/images/UpcomingWord.svg" alt="word">
                                        </span>
                                        <span class="install-in-browser">Mac版Word</span>
                                    </li>
                                    <li>
                                        <span class="browser-icon upcoming-icon">
                                            <img src="../../../assets/images/UpcomingSafari_icon.png" alt="safari">
                                        </span>
                                        <span class="install-in-browser">Safari
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="contact" id="footerEmailBox">
                                <form class="form-inline" (ngSubmit)="subscribeNow()" [formGroup]="footerFroms">
                                    <div class="form-group mx-sm-3 mb-2 ml-0" [ngClass]="(!footerFroms.get('footeremailform').valid && footerFroms.get('footeremailform').dirty) || (footerFroms.get('footeremailform').touched && footerFroms.get('footeremailform').pristine) ? 'TextFiledError' : '' ">

                                        <mat-form-field appearance="outline">
                                            <mat-label>您用來接收Trinka新聞的電子郵件</mat-label>
                                            <input matInput placeholder="" formControlName="footeremailform" class="form-control" name="email">
                                        </mat-form-field>
                                    </div>
                                    <button type="submit" [disabled]="!footerFroms.valid" id="footerSubscribe" class="btn btn-primary mb-2">訂閱</button>
                                </form>
                            </div>

                        </div>


                    </div>
                    <div class="row">

                        <div class="col-lg-12">
                            <div class="row footer_menu_wrap">
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>公司介紹</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/aboutus']" routerLinkActive="active">關於我們</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/contactus']" routerLinkActive="active">聯繫我們</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/workwithus']" routerLinkActive="active">加入我們</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/affiliates']" routerLinkActive="active">聯盟行銷</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/accomplishments']" routerLinkActive="active">Accomplishments</a>
                                            </li> -->
                                        </ul>
                                    </div>
                                    <div class="footer_menu_one">
                                        <h3>學到更多</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a href="https://www.trinka.ai/blog/"  target="_blank">部落格</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/examples']" routerLinkActive="active">範例</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/faqs']" routerLinkActive="active">常見問答</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>特色</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/features']" routerLinkActive="active">所有功能</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/plagiarism-check']" routerLinkActive="active">抄襲檢測</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/tw/features/auto-file-edit" routerLinkActive="active">自動文件編輯</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/tw/features/publication-readiness-checks" routerLinkActive="active">出版準備檢查</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/citation-checker']" routerLinkActive="active">引文檢查器</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/consistency-check']" routerLinkActive="active">一致性檢查</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/personal-dictionary']" routerLinkActive="active">個人詞典</a>
                                            </li>

                                            <li>
                                                <a href="https://www.enago.com/plagiarism-checker/" target="_blank">抄襲檢查</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/credits']" routerLinkActive="active">Trinka積分</a>
                                            </li>

                                        </ul>
                                    </div>
                                </div>

                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>企業</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" routerLinkActive="active">生命科學、醫學和製藥</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/language-services-publishing-and-media']" routerLinkActive="active">語言服務、出版和媒體</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/academic-institutions']" routerLinkActive="active">學術機構</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/k12-and-elearning']" routerLinkActive="active">K-12和數位化學習</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/technology-platforms']" routerLinkActive="active">技術平台</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">企業集成</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">語法檢查工具API</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/documark']" routerLinkActive="active">DocuMark</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Trinka API</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Trinka On-Premise</a>
                                            </li> -->


                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>競品比較</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/trinka-vs-grammarly']" routerLinkActive="active">Trinka vs. Grammarly</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-ginger']" routerLinkActive="active">Trinka vs. Ginger</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-languagetool']" routerLinkActive="active">Trinka vs. LanguageTool</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-writefull']" routerLinkActive="active">Trinka vs. Writefull</a>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>資源</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/grammar-checker']" routerLinkActive="active">文法檢查</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/punctuation-checker']" routerLinkActive="active">標點符號檢查工具</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/spell-checker']" routerLinkActive="active">拼寫檢查工具</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/sentence-checker']" routerLinkActive="active">句子檢查工具</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="purple-bg">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <p>若需要協助，請寫信到
                        <a href="mailto:support@trinka.ai">support@trinka.ai</a>給我們
                    </p>
                </div>
            </div>
        </div>
    </div> -->
    <div class="footer-separator"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-middle">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="powerd-by">
                                <div class="powered-by-left">
                                    <h3>技術支援：</h3>
                                    <p>
                                        <a href="https://www.enago.com/" target="_blank" class="footer_logos">
                                            <img src="../../../assets/images/enago-logo.png" alt="enago-english-editing-service" class="enago logo" />
                                        </a>
                                    </p>
                                </div>
                                <div class="powered-by-right">
                                    <p>Enago是深受全球研究界信賴的作者服務品牌，已幫助125多個國家/地區的研究人員促進研究交流並成功發表。</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="footer_menu_one footer_menu_last">
                                <h3>英論閣服務</h3>
                                <ul class="ftr-menu">
                                    <li>
                                        <a href="https://www.enago.tw/editing-services.htm" target="_blank">英文編輯</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.tw/publication-support/" target="_blank">出版協助</a>
                                    </li>
                                    <li>
                                        <a href="https://ulatus.tw/" target="_blank">翻譯服務</a>
                                    </li>
                                    <li>
                                        <a href="https://voxtab.com/" target="_blank">轉錄和字幕服務</a>
                                    </li>
                                    <li>
                                        <a href="https://lifesciences.enago.com/" target="_blank">全球醫療通訊</a>
                                    </li>
                                    <li>
                                        <a href="https://www.read.enago.com/" target="_blank">文獻回顧與分析工具</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-bottom">
                    <div class="row">
                        <div class="col-md-6">
                            <p>© Crimson AI, {{ latestYear }}. Made in India.</p>
                            <ul class="ftr-menu1">
                                <li>
                                    <a href="mailto:support@trinka.ai">support@trinka.ai</a>
                                </li>
                                <li>
                                    <a id="PrivacyButton" href="https://www.trinka.ai/privacypolicy/" target="_blank">隱私政策</a>
                                </li>
                                <li>
                                    <a id="termsofserviceButton" href="https://www.trinka.ai/termsofservices/" target="_blank">服務條款</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <div class="follow-us">
                                <h3>關注我們:</h3>
                                <ul class="social-media">
                                    <li>
                                        <a href="https://www.facebook.com/thetrinkaai/" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/thetrinkaai/" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://x.com/ai_trinka" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/thetrinkaai" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-linkedin"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-youtube-play"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div class="language_sections" id="languageDropDown">
                                <i class="fa fa-globe" aria-hidden="true"></i>
                                <span>繁体中文</span>
                                <ul class="drop">
                                    <li>
                                        <a href="https://www.trinka.ai/">English</a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/jp/">
                                            日本語
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://trinka.enago.cn/">
                                            简体中文
                                        </a>
                                    </li>
                                    <li class="selected">
                                        <a>
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                            繁体中文
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/kr/">
                                            한국어
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/es/">
                                            Español
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/pt/">
                                            Português
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<div id="emailSubscribePopup" class="modal fade show" *ngIf="subscribePopup">
	<div class="modal-dialog modal-confirm">
		<div class="modal-content">
			<div class="modal-header flex-column">
				<div class="icon-box">
					<i class="material-icons">&#xE5CA;</i>
				</div>						
				<h4 class="modal-title w-100">Thank you for subscribing to our newsletter</h4>	
                <button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
			</div>
			<div class="modal-body">
                <p>Your subscription has been confirmed.</p>
			</div>
			<div class="modal-footer justify-content-center">
				<button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="btn btn-secondary" data-dismiss="modal">OK</button>
				<!-- <button type="button" class="btn btn-danger">Delete</button> -->
                <p>Note: If at any point of time you wish to opt out from the newsletters, you can simply click on "Unsubscribe" link at the bottom of newsletter.</p>
			</div>
		</div>
	</div>
</div> 
